import { render, staticRenderFns } from "./BodyRegister1.vue?vue&type=template&id=45d9f07f"
import script from "./BodyRegister1.vue?vue&type=script&lang=ts"
export * from "./BodyRegister1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports